import { motion } from 'framer-motion'
import React, { useEffect, useRef, useState } from 'react'
import x from '../../assets/icons/close.svg'
import photo from '../../assets/icons/phot.svg'
import editSocialMedia from '../../apis/editSocialMedia'

const EditMedia = ({ active, close, media, updateData }) => {
  const popupref = useRef(null)
  const [mediaData, setMediaData] = useState({
    title: media.title || '',
    address: media.address || '',
  })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [imageFile, setImageFile] = useState(null)
  const [preview, setPreview] = useState(media?.icon || null)

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleDrop = (e) => {
    e.preventDefault()
    const file = e.dataTransfer.files[0]
    setImageFile(file)
    setPreview(URL.createObjectURL(file))
  }

  const handelEditMedia = async (e) => {
    e.preventDefault()

    setLoading(true)
    let edited = false
    let formData = new FormData()
    if (mediaData.title !== media.title) {
      formData.append('title', mediaData.title)
      edited = true
    }
    if (mediaData.address !== media.address) {
      formData.append('address', mediaData.address)
      edited = true
    }

    if (imageFile) {
      formData.append('icon', imageFile)
      edited = true
    }

    if (edited) {
      try {
        await editSocialMedia(formData, media.id)

        updateData()
        close()
      } catch (error) {
        setError(error.response.data.message)
      } finally {
        setLoading(false)
      }
    }
  }

  const handelInputChange = (e) => {
    const { name, value } = e.target
    setMediaData((prevData) => ({ ...prevData, [name]: value }))
    setError('')
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [popupref, close])

  useEffect(() => {
    if (active) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [active])

  const clearFiles = (e) => {
    e.preventDefault()
    setPreview(null)
    setImageFile(null)
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    setImageFile(file)
    setPreview(URL.createObjectURL(file))
    setError('')
  }
  return (
    <motion.div
      className=" fixed inset-0 bg-overlay/30 w-screen  z-40 h-screen grid place-items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        ref={popupref}
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
        className=" w-1/3 min-h-10 overflow-hidden bg-white rounded-lg flex flex-col justify-center items-center"
      >
        <form onSubmit={handelEditMedia} className="w-full">
          <div className=" w-full px-8 py-5 flex flex-col gap-8 ">
            <div className="flex border-b-[1px] pb-4 justify-between border-b-darkBlue w-full">
              <div>Edit {media?.title || 'Social Media'}</div>
              <img src={x} onClick={close} className=" cursor-pointer" alt="" />
            </div>
            <div className="rounded-xl p-4 border border-b-darkBlue">
              <label
                htmlFor="image"
                className="cursor-pointer relative"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <input
                  id="image"
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="hidden"
                />
                {preview ? (
                  <div className="absolute top-2 right-2 z-10">
                    <img
                      onClick={clearFiles}
                      src={x}
                      alt="Clear"
                      className="cursor-pointer"
                    />
                  </div>
                ) : (
                  <div className="flex justify-center items-center">
                    Choose or Drop a File
                  </div>
                )}
                <img
                  src={preview || photo}
                  alt="Preview"
                  className="w-full h-28 object-contain"
                />
              </label>
            </div>

            <div>
              <label>Title </label>
              <div className=" w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
                <input
                  value={mediaData.title}
                  name="title"
                  id="title"
                  onChange={handelInputChange}
                  className=" w-full focus:outline-none"
                  placeholder="title"
                />
              </div>
            </div>
            <div>
              <label>Link Address </label>
              <div className=" w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
                <input
                  value={mediaData.address}
                  name="address"
                  id="address"
                  onChange={handelInputChange}
                  className=" w-full focus:outline-none"
                  placeholder="currency price for dollar"
                />
              </div>
            </div>
          </div>
          {error && (
            <div className=" w-full flex justify-center py-3 items-center">
              <span className=" bg-red/20 px-3 py-1 text-red rounded">
                {error}
              </span>
            </div>
          )}
          <button
            disabled={loading}
            className=" disabled:bg-darkBlue/50 bg-blueButton text-white text-center p-4 w-full "
          >
            Edit
          </button>
        </form>
      </motion.div>
    </motion.div>
  )
}

export default EditMedia
